// Alturas de toolbars y componentes de layout
export const TOOLBAR_HEIGHT = 70; // en pixels
export const TOOLBAR_HEIGHT_PX = '70px'; // para usar en sx props

// Alturas calculadas según contexto
export const HOME_APPBAR_HEIGHT = TOOLBAR_HEIGHT * 2; // 140px (2 toolbars en home)
export const STANDARD_APPBAR_HEIGHT = TOOLBAR_HEIGHT; // 70px (1 toolbar en otras rutas)
export const FILTERS_HEIGHT = TOOLBAR_HEIGHT; // 70px (toolbar de filtros)

// Helper para calcular altura del AppBar según ruta y filtros
export const getAppBarHeight = (pathname, showFilters = false) => {
  const isHomePage = pathname === '/';
  const baseHeight = isHomePage ? HOME_APPBAR_HEIGHT : STANDARD_APPBAR_HEIGHT;
  const filtersHeight = showFilters ? FILTERS_HEIGHT : 0;
  return baseHeight + filtersHeight;
};


